import React from 'react';
import { useAtomValue } from 'jotai';
import { Layout } from 'antd';
import UsageDashboardHeader from './UsageDashboardHeader';
import AccountView from './AccountView/AccountView';
import MetricsPanel from './MetricsPanel/MetricsPanel';
import { useGetCustomerList } from './hooks/dataFetcherhooks';
import { tableViewSwitchAtom } from './atoms';
import { MetricsTable } from './MetricsTable';
import { UsageExportRegistrar } from './UsageExportRegistrar';
import { SiderContent, SiderHeader, SiderLayout, SiderWrapper } from './styled';

const UsageDashboard = () => {
  const customerList = useGetCustomerList({ enabled: true });
  const tableViewOpen = useAtomValue<boolean>(tableViewSwitchAtom);

  return (
    <SiderLayout>
      <UsageExportRegistrar />
      <SiderWrapper>
        <AccountView isCustomerListFetching={customerList.isFetching} />
      </SiderWrapper>
      <Layout>
        <SiderHeader>
          <UsageDashboardHeader isCustomerListFetching={customerList.isFetching} />
        </SiderHeader>
        <SiderContent style={tableViewOpen ? undefined : { backgroundColor: 'white' }}>
          {tableViewOpen ? (
            <MetricsTable />
          ) : (
            <MetricsPanel isCustomerListFetching={customerList.isFetching} />
          )}
        </SiderContent>
      </Layout>
    </SiderLayout>
  );
};

export default UsageDashboard;
